import React from "react";
import { Grid, Paper, Typography, Box } from "@material-ui/core";
import { ResizableTable } from "../../../components/resizableTable/ResizableTable";

const UpsellCrossSellPaper = ({
  classes,
  paperTitle,
  createUpsellCrossSellDetailColumns,
  handleChangeLocation,
}) => {
  return (
    <Grid item xs={12}>
      <Paper className={classes.paper}>
        <Box display="flex" flexDirection="column" alignItems="center" mb={3}>
          <Typography variant="h5" className={classes.title}>
            Upsell-Cross Sell tracker detail
          </Typography>
          <span className={classes.updateFrequency}>{"Live Data"}</span>
        </Box>

        <Grid container spacing={2}>
          <Grid item xs={12}>
            <ResizableTable
              columns={createUpsellCrossSellDetailColumns([
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
              ])}
              rows={[
                ...Array.from({ length: 6 }, (_, i) => ({
                  rowLabel: "",
                  February_customer: "",
                  February_target: "",
                  February_actual: "",
                  March_customer: "",
                  March_target: "",
                  March_actual: "",
                  April_customer: "",
                  April_target: "",
                  April_actual: "",
                  May_customer: "",
                  May_target: "",
                  May_actual: "",
                  June_customer: "",
                  June_target: "",
                  June_actual: "",
                  July_customer: "",
                  July_target: "",
                  July_actual: "",
                  label: `row_${i + 1}`,
                })),
                {
                  rowLabel: "TOTAL =",
                  February_customer: "",
                  February_target: "",
                  February_actual: "",
                  March_customer: "",
                  March_target: "",
                  March_actual: "",
                  April_customer: "",
                  April_target: "",
                  April_actual: "",
                  May_customer: "",
                  May_target: "",
                  May_actual: "",
                  June_customer: "",
                  June_target: "",
                  June_actual: "",
                  July_customer: "",
                  July_target: "",
                  July_actual: "",
                  label: "Total",
                },
              ]}
              getCellValue={(row, field) => row[field] || ""}
              getCellStyle={(row, field) => {
                if (row.label === "Total") {
                  return { fontWeight: 600, backgroundColor: "#f5f5f5" };
                }
                return {};
              }}
              rowKey="label"
              stickyFirstColumn={true}
              maxWidth="100%"
              onRowClick={(row) =>
                handleChangeLocation("drilldownOnGraph", row, "upsellCrossSell")
              }
            />
          </Grid>
        </Grid>

        <Box mt={4}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <ResizableTable
                columns={createUpsellCrossSellDetailColumns([
                  "August",
                  "September",
                  "October",
                  "November",
                  "December",
                  "January",
                ])}
                rows={[
                  ...Array.from({ length: 6 }, (_, i) => ({
                    rowLabel: "",
                    August_customer: "",
                    August_target: "",
                    August_actual: "",
                    September_customer: "",
                    September_target: "",
                    September_actual: "",
                    October_customer: "",
                    October_target: "",
                    October_actual: "",
                    November_customer: "",
                    November_target: "",
                    November_actual: "",
                    December_customer: "",
                    December_target: "",
                    December_actual: "",
                    January_customer: "",
                    January_target: "",
                    January_actual: "",
                    label: `row_${i + 1}`,
                  })),
                  {
                    rowLabel: "TOTAL =",
                    August_customer: "",
                    August_target: "",
                    August_actual: "",
                    September_customer: "",
                    September_target: "",
                    September_actual: "",
                    October_customer: "",
                    October_target: "",
                    October_actual: "",
                    November_customer: "",
                    November_target: "",
                    November_actual: "",
                    December_customer: "",
                    December_target: "",
                    December_actual: "",
                    January_customer: "",
                    January_target: "",
                    January_actual: "",
                    label: "Total",
                  },
                ]}
                getCellValue={(row, field) => row[field] || ""}
                getCellStyle={(row, field) => {
                  if (row.label === "Total") {
                    return { fontWeight: 600, backgroundColor: "#f5f5f5" };
                  }
                  return {};
                }}
                rowKey="label"
                stickyFirstColumn={true}
                maxWidth="100%"
                onRowClick={(row) =>
                  handleChangeLocation(
                    "drilldownOnGraph",
                    row,
                    "upsellCrossSell",
                  )
                }
              />
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </Grid>
  );
};

export default UpsellCrossSellPaper;
